module.exports = __webpack_public_path__ + "static/media/slide16.792d31b0.jpg";